module.exports = __webpack_public_path__ + "static/media/horrormax-banner-grave-caller.5f88e8d5.jpg";